// extracted by mini-css-extract-plugin
export default {"link":"SearchCard_link__ptJ87","grid":"SearchCard_grid__D7PhC","text":"SearchCard_text__79I8f"};